import { createContext, useContext, useReducer  } from 'react'
import { useData } from './Data'
import { useNavigate } from 'react-router'
import koalition from '../api/koalition'

const UserContext = createContext()

const useUser = () => {
    const context = useContext(UserContext)

    if (context === undefined) throw new Error('useUser must be used within a UserProvider')

    return context
}

const UserProvider = ({ children }) => {
    const reducer = (state, user) => {
        return user
    }

    const [$state, dispatch] = useReducer(reducer, {})
    const data = useData()

    const save = (user) => dispatch(user)
    const login = (jwt) => {
        koalition.defaults.headers.common.Authorization = `Bearer ${jwt}`
        data.save('jwt', jwt)
        localStorage.setItem('jwt', jwt)
    }
    const logout = () => {
        localStorage.removeItem('jwt')
        dispatch(null)
        data.save('jwt', null)
        window.location.href = `${window.location.origin}/login`
    }

    return (
        <UserContext.Provider value={{ $state, save, login, logout }}>
            {children}
        </UserContext.Provider>
    )
}

export { useUser, UserProvider }